import { render, staticRenderFns } from "./carl-von-schubert.vue?vue&type=template&id=33384bed&scoped=true"
import script from "./carl-von-schubert.vue?vue&type=script&lang=js"
export * from "./carl-von-schubert.vue?vue&type=script&lang=js"
import style0 from "./carl-von-schubert.vue?vue&type=style&index=0&id=33384bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33384bed",
  null
  
)

export default component.exports